import React from 'react'

const HistorySummary = ({ totalData, page, totalPages, setPage }) => {
  return (
    <div className="totalbayar">
      <h2 className="ringkasan">Ringkasan transaksi</h2>
      <div className="isi-total">
        <p className="totalharga">Total Transaksi</p>
        <p className="total">{totalData} Pembelian</p>
        <p className="totalharga">Halaman</p>
        <p className="total">{page} dari {totalPages}</p>
      </div>

      {totalPages > 1 && (
        <div style={{ display: 'flex', gap: '10px', marginTop: '15px' }}>
          <button
            disabled={page <= 1}
            onClick={() => setPage((p) => Math.max(p - 1, 1))}
            style={{
              flex: 1,
              padding: '10px',
              borderRadius: '8px',
              border: '1px solid #00a651',
              background: page <= 1 ? '#eee' : '#fff',
              color: page <= 1 ? '#999' : '#00a651',
              fontWeight: 'bold',
              cursor: page <= 1 ? 'not-allowed' : 'pointer',
              outline: 'none'
            }}
          >
            Sebelumnya
          </button>
          <button
            disabled={page >= totalPages}
            onClick={() => setPage((p) => Math.min(p + 1, totalPages))}
            style={{
              flex: 1,
              padding: '10px',
              borderRadius: '8px',
              border: '1px solid #00a651',
              background: page >= totalPages ? '#eee' : '#00a651',
              color: page >= totalPages ? '#999' : '#fff',
              fontWeight: 'bold',
              cursor: page >= totalPages ? 'not-allowed' : 'pointer',
              outline: 'none'
            }}
          >
            Selanjutnya
          </button>
        </div>
      )}
    </div>
  )
}

export default HistorySummary
